import 'imba/preflight.css'
import './wordFrequencyFinder.imba'
import {nt-freq-list} from './bible/nt-freq-list.imba'

global css html	w:100% h:100% m:0 ff:sans
global css body w:100% h:100% m:0
# import * as dictionary from './data.json'
import {VidaSearch} from './VidaSearch'

# TAG[epic=tag]: close-icon
tag close-icon
	<self[d:block]>
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
			<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">

# TAG[epic=tag]: shuffle-icon
tag shuffle-icon
	<self>
		<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-shuffle" viewBox="0 0 16 16">
			<path fill-rule="evenodd" d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z"/>
			<path d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z"/>


import {dict} from './dict.imba'

# TAG[epic=tag]: json-results
tag json-results
	prop query = ''
	def render
		<self[p:6 d:block bg:gray8 c:gray3]>
			<pre> "export let dict = ["
				for dictItem, itemindex in dict
					<div>
						for engItem in dictItem.engArray when VidaSearch(query, "{engItem.engWord}")
								<div>
									if itemindex isnt 0
										<pre> "	---"
									<code[d:block]>
										<pre> 	"	wordCham: \"{dictItem.wordCham}\""
										<pre> 	"	wordIpa: \"{dictItem.wordIpa}\""
										<pre>
											if dictItem.wordReviewed is "✅"
												"	wordReviewed: true"
											else
												"	wordReviewed: false"
										<pre> 	"	wordNotes: \"{dictItem.wordNotes}\""
									for engItem, index in dictItem.engArray
										<div[d:block]>
											let grouplength = dictItem.engArray.length
											if dictItem.engArray.indexOf(engItem) >= 1
												<pre> "		---"
											else
												<pre> 	"	engArray: ["
											<pre> 	"		engWord: \"{engItem.engWord}\""
											<pre> 	"		engInfo: \"{engItem.engInfo}\""
											<pre>	"		engUse: \"{engItem.engUse}\""
											if (index + 1) is grouplength
												<pre> 	"		]"
									for khItem, index in dictItem.khArray
										let grouplength = dictItem.khArray.length
										<div[d:block]>
											if VidaSearch(query, khItem.khWord)
												if dictItem.khArray.indexOf(khItem) >= 1
													<pre> "		---"
												else
													<pre> 	"	khArray: ["
												<pre> 	"		khWord: \"{khItem.khWord}\""
												<pre> 	"		khInfo: \"{khItem.khInfo}\""
												<pre>	"		khUse: \"{khItem.khUse}\""
												if (index + 1) is grouplength
													<pre> 	"		]"
				<pre> "]"
# TAG[epic=tag]: word-item
tag word-item
	css self
		bg:white
	css .card 
		pos:relative
	css .card-row
		py:1em
		bdb:1px solid indigo1
	css .close-button
		tween:all .2
		pos:absolute
		d:flex jc:center ai:center
		r:0 t:2em
		fill:indigo5
		cursor:pointer
		zi:10
		>>> svg size:50px
	def render
		<self[o@off:0 o@in:1] ease>
			css d:block px:6 min-height:100vh
			let index = route.params.id
			let engWords = dict[index].engArray
			let chamWord = dict[index].wordCham
			css 
				d:flex 
				fld:column
			# Close Card Button
			<div.card>
				<a.close-button route-to="/list"> 
					<close-icon>
				for word in engWords
					# WORD CARD
					<div.card-row>
						# Word Card Header
						<div> 
							css 
								# ai:baseline 
								# d:flex 
								flw:wrap 
								# bdb:2px solid indigo0
							<h2> 
								css fs:xl fw:bold mr:1
								"{word.engWord} "
							<h2.chamWord> 
								css c:indigo4 fs:xl mr:1 ff:monospace
								"[{chamWord}] "
							<span.engUse> 
								css c:warm4 fw:bold fs:xl
								"{word.engUse}"

						# Word Info
						<div> 
							<p[fs:sm d:block]> "{word.engInfo}"
						
# TAG[epic=tag]: work-list
tag word-list
	def scrollToTop
		window.scrollTo(0,0)
	def render
		<self>
			css bg:warm0 d:block min-height:100vh
			<div >
				css bg:white px:3 pt:6 pb:4 bxs:sm, xxl cursor:pointer
				for dictItem, itemIndex in dict
					<div route-to="/word/{itemIndex}/" @click.scrollToTop>
						for engItem, engIndex in dictItem.engArray when VidaSearch(query, engItem.engWord)
							<div[bdb:2px solid warm1 @hover:2px solid white px:3 py:2 fw:500 c:warm9 bg:white @hover: gray1]>
								<a><p> engItem.engWord
# TAG[epic=tag]: app-root
tag app-root
	# PROPS
	prop query = ''
	prop randomNum = 1
	def createRandomNum
		return randomNum = Math.floor(Math.random() * Math.floor(dict.length - 1))
	def render
		<self[d:vflex min-height:100%]>
			# <pre> <code>
			# 	for item in nt-freq-list
			# 		<span> "{item.word},\t{item.count},\t{item.rank}\n"
			<div[flex:0 0]>
				css bg:indigo7 py:1em
				<h1[c:white ta:center ff:sans fw:bold]> 
					<a route-to="/"> "English to Cham"
					<span> " - "
					<a route-to="/list"> "{dict.length} words"
					<span> " - by "
					<a href="https://ericvida.com" target="_blank"> "Eric Vida"
						css c:indigo3 td:underline
				
			<div.results[d:vflex flg:1 pb:80px]>
				<word-item route="/word/:id">
				<word-list[o@off:0 o@in:1] ease route=("/list" or "/$") bind:query=query>
				<json-results route="/json" bind:query=query>
			<div[flg:0 fls:1 b:0 pos:fixed w:100% rdt:1.2em].searchbar>
				css bg:indigo9 shadow:0 0 20px 20px indigo9/20 c:white p:4
				<div[d:flex].search-bar-wrapper>
					# Search Bar
					<input$input route-to="/list" placeholder="Type to Search:" bind=query>
						css px:6 py:3 rdl:xl flg:1 h:50px bd:0
							border: 0px solid
							mr:-1px
							c:indigo9
					# clear search
					<button alt="clear search" route-to="/$" @click=(query='', $input.value = '')>
						css 
							size:50px
							rdr:xl
							bg:indigo1 @hover: indigo5
							fill:indigo7
							bd:0px solid
							mr:1em
						<close-icon>
					# Shuffle button
					<button alt="random word" route-to="/word/{randomNum}" @click.createRandomNum>
						css 
							size:50px
							rd:xl
							p:8px
							bg:indigo1 @hover: indigo5
							c:indigo7
							bd:0px solid
						<shuffle-icon>
				# <span> "Created by Eric Vida, All rights reserved."
				# <a[ta:center c:indigo2 td@hover:underline] route-to="/json"> "See Data"

imba.mount <app-root>